<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>{{isPaid ? 'PAIEMENT EFFECTUÉ AVEC SUCCÈS' : 'PAIEMENT NON EFFECTUÉ' }}</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>{{isPaid ? 'PAIEMENT EFFECTUÉ AVEC SUCCÈS' : 'PAIEMENT NON EFFECTUÉ' }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="post-job-area pb-170 pt-100" *ngIf="isPaid">
    <div class="container">
        <div class="payment-success-content">
            <div class="success-icon">
                <i class="icofont-check-circled"></i>
            </div>
            <div class="success-text">
                <h4>Paiement Effectué avec succès</h4>
                <p>
                    Votre paiement a été effectué avec succès.
                </p>
                <p>
                    Nous vous remercions pour votre inscription et nous vous
                    souhaitons la bienvenue.
                </p>
                <p>
                    Cliquez sur le bouton "<strong>Finaliser</strong>" pour accéder à votre compte.
                </p>
                
                <div class="row pt-5">
                    <div class="col-lg-6">
                        <button routerLink="/login" class="btn btn-green" type="submit">
                            Finaliser <i class="icofont-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="post-job-area pb-170 pt-100" *ngIf="!isPaid">
    <div class="container text-left">
        <div class="payment-failure-content">
            <div class="failure-icon">
                <i class="icofont-close-circled"></i>
            </div>
            <div class="failure-text">
                <h4>Paiement non effectué</h4>
                <p>
                    Votre paiement n'a pas été effectué.
                </p>
                <p>
                    Veuillez réessayer.
                </p>
                
                <div class="row pt-5">
                    <div class="col-lg-6">
                        <button routerLink="/company/payment-first-step/{{reference}}" class="btn btn-green" type="submit">
                            Réessayer <i class="icofont-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


